import { initFetchState } from "../helpers";
import profileService from "../../services/ProfileService";
export default {
  myProfile: initFetchState(),
  managedProviders: initFetchState(),
  selectedProvider: profileService.selectedProvider
};